import { useState } from 'react';
import { useDatos } from '../../datos/DatosContext';
import { useRuta } from '../../lib/ruta';
import { Cabecera, GrupoChips } from '../../componentes/ui/basicos';

export const claseEstado = (e: string) =>
  e === 'Completado' ? 'tag moss' : e === 'En curso' ? 'tag dusk' : e === 'Pendiente' ? 'tag warn' : 'tag';

export function Cursos() {
  const { datos } = useDatos();
  const { ir } = useRuta();
  const [filtro, setFiltro] = useState('Todos');
  const lista = datos.actividades.filter((c) => filtro === 'Todos' || c.estado === filtro);

  return (
    <div className="stack-lg">
      <Cabecera antetitulo="Elegir una práctica" titulo="Cursos y ejercicios" />
      <GrupoChips etiqueta="Filtrar por estado" opciones={['Todos', ...datos.opciones.estadosActividad]} seleccion={filtro} onElegir={setFiltro} desplazable />
      <div className="stack-sm">
        {lista.map((c) => (
          <button key={c.id} className="listbtn" onClick={() => ir('/cursos/' + c.id)}>
            <span className="between"><span className="muted small">{c.curso}</span><span className={claseEstado(c.estado)}>{c.estado}</span></span>
            <span style={{ fontWeight: 600, fontSize: 17 }}>{c.titulo}</span>
            <span className="row"><span className="tag">{c.tipo}</span>{c.respuesta ? <span className="muted small">Con tu respuesta</span> : null}</span>
          </button>
        ))}
        {!lista.length ? <p className="muted">No hay actividades en este estado.</p> : null}
      </div>
    </div>
  );
}
